export const environment = {
  production: true,
  apiurl:"https://finalapi.soilchargertechnology.com/api/"
  // apiurl:"https://www.soilchargertechnology.com/api/api/" //Live
  //apiurl:"https://soilapinew.sumagotest.in/api/"
  // apiurl:"http://api.soilchargertechnology.com/public/api/" //Not In Use
  // apiurl:"http://localhost/api/api/"
};
